import React, { createContext, useContext, useEffect, useState } from 'react';
import websocketService from '../services/websocketService';

const WebSocketContext = createContext();

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
};

export const WebSocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Check connection status periodically
    const checkConnection = () => {
      setIsConnected(websocketService.isConnected());
    };

    // Initial check
    checkConnection();

    // Set up interval to check connection
    const interval = setInterval(checkConnection, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const value = {
    isConnected,
    joinProject: (projectId) => websocketService.joinProject(projectId),
    leaveProject: (projectId) => websocketService.leaveProject(projectId),
    subscribe: (event, callback) => websocketService.subscribe(event, callback),
    websocketService
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
};